import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation  } from 'react-i18next';
import * as ViewManagementModule from '../../../Modules/ViewManagementModule';
import { connect } from 'react-redux';
// import './../SingleMenuItem/SingleMenuItem.css';

export type Props = {
    /** dane wyświetlanej strony   */
    page: ViewManagementModule.Types.Page;
};

export type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

export type ConnectedDispatch = {
    t: Function;
    setActivePage: Function;
};

const SingleMenuItem = (props: Props & ConnectedProps & ConnectedDispatch) => {
    const { t } = props;
    return (
        <li onClick={() => {
                if (props.setActivePage) {
                    props.setActivePage(props.page);
                }
            }}
        >
            <NavLink exact to={props.page.url} className="menu-left__navlink">
                <div className={`menu-left__item ${props.viewManagementStore.sidebarMenuExpanded && 'menu-left__item--expanded'}`}>
                    <img src={props.page.iconSrc || '/images/icons/home.svg'} alt={t(props.page.title)} title={t(props.page.title)} className="menu-left__icon-item"/>
                    {props.viewManagementStore.sidebarMenuExpanded && <span className="menu-left__title">{t(props.page.title)}</span>}
                </div>
            </NavLink>
        </li>
    );
};

function mapStateToProps(state: ConnectedProps) {
    return {
        viewManagementStore: state.viewManagementStore
    };
}

function mapDispachToProps(dispatch: any) {
    return {
        setActivePage: (page: ViewManagementModule.Types.Page) => dispatch(ViewManagementModule.Actions.setActivePage(page))
        // setLanguage: (lang: string) => dispatch(ViewManagementModule.Actions.setLanguage(lang))
    };
}
/**
 * Pojedynczy element głownego menu aplikacji
 */
export default withTranslation ('mainMenu')(
    connect<{}, {}, Props>(
        mapStateToProps,
        mapDispachToProps
    )(SingleMenuItem) as React.ComponentType<any>
) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Layout/SingleMenuItem/SingleMenuItem.tsx